<mom-header-with-logo-and-right-button>
  <ng-content slot="title" select="[slot=title]"></ng-content>
  <ion-menu-button slot="button" color="dark" autoHide="false"></ion-menu-button>
</mom-header-with-logo-and-right-button>
